var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6092 14.1206L14.6091 14.1206L14.6081 14.1264C14.5269 14.5839 14.1306 14.9161 13.6648 14.9161H1.50055C1.31446 14.9161 1.14005 14.8345 1.02096 14.6923C0.902776 14.5512 0.853044 14.3671 0.884 14.1863L2.53375 6.33604C2.60074 6.05097 2.68109 5.90063 2.77525 5.81467C2.86089 5.73648 3.01052 5.66455 3.33107 5.66455H15.5024C15.8417 5.66455 16.1193 5.93725 16.1274 6.27467L16.1255 6.29561L14.6092 14.1206Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72118 2.97697L5.78309 2.99938L5.84892 2.99936L13.8354 2.99736C13.8354 2.99736 13.8355 2.99736 13.8355 2.99736C14.1798 2.9974 14.4606 3.27823 14.4606 3.62251V4.24767H3.16708C2.65529 4.24767 2.18981 4.40227 1.82545 4.73215C1.46525 5.05825 1.23656 5.52588 1.1362 6.096L0.875 7.33906V2.28897C0.875 1.94466 1.15584 1.66382 1.50016 1.66382H4.50062C4.58381 1.66382 4.66914 1.69871 4.78103 1.81318C4.90064 1.93556 5.00953 2.10611 5.14316 2.31899L5.14729 2.32557C5.19791 2.40625 5.27557 2.53001 5.35359 2.63918C5.39341 2.69488 5.43893 2.75477 5.48567 2.80632C5.50904 2.8321 5.53754 2.86118 5.57001 2.88816C5.59866 2.91198 5.65064 2.95143 5.72118 2.97697Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesOutline);
export default __webpack_public_path__ + "static/media/categories-outline.0b43cc3c2c88ba73813a5a98c0a09a01.svg";
export { ForwardRef as ReactComponent };